
import React from "react";
import { Helmet } from "react-helmet-async";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const NotFound: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 text-center">
      <Helmet>
        <title>404 - Page Not Found | Hivetivity</title>
        <meta name="robots" content="noindex, follow" />
        <meta name="description" content="Sorry, the page you requested cannot be found on Hivetivity." />
        <link rel="canonical" href="https://hivebubble.com/404" />
      </Helmet>
      <h1 className="text-9xl font-bold text-rosterly-purple">404</h1>
      <h2 className="mt-4 text-2xl font-bold text-gray-800">Page Not Found</h2>
      <p className="mt-2 text-gray-600">The page you're looking for doesn't exist or has been moved.</p>
      <Button 
        className="mt-6 bg-rosterly-purple hover:bg-rosterly-dark-purple"
        asChild
      >
        <Link to="/dashboard">Return to Dashboard</Link>
      </Button>
    </div>
  );
};

export default NotFound;
